import { FetchInterceptor } from "src/app/helpers/Index";
import { environment } from "src/environments/environment";

const endpoint = "PromoCode";
const json = { "Content-Type": "application/json" };
const url = (path: string) => `${environment.server.apiURL}/${endpoint}${path}`;

/** Discount codes. */
export const PromoCodeService = {
	endpoint,
	status: async () => await FetchInterceptor(url("/Status"), {headers: json, method: "GET"}),
	getAll: async () => await FetchInterceptor(url(""), {headers: json, method: "GET"}),
	add: async (data: any) => await FetchInterceptor(url(""), {body: JSON.stringify(data), headers: json, method: "POST"}),
	update: async (id: number, data: any) => await FetchInterceptor(url(`/${id}`), {body: JSON.stringify(data), headers: json, method: "POST"}),
	remove: async (id: number) => await FetchInterceptor(url(`/${id}`), {headers: json, method: "DELETE"}),
	/**
	 * Try a code against a basket. Records nothing — a fan typing a code and
	 * closing the tab must not burn a redemption. The slug carries the tenant,
	 * since this is anonymous.
	 */
	apply: async (clubSlug: string, code: string, subtotalPence: number, fanId?: number) =>
		await FetchInterceptor(url("/Apply"), {body: JSON.stringify({ clubSlug, code, fanId, subtotalPence }), headers: json, method: "POST"})
}
